<template>
  <div class="rating-stars">
    <IconStart
      v-for="i in 5"
      :id="`${i}_${randomNumbers}`"
      :key="i"
      :class="{ filled: stars >= i, half: stars > i - 1 && stars < i }"
    />
  </div>
</template>

<script>
import IconStart from './RatingStar';

export default {
  components: { IconStart },
  props: {
    rating: { type: [Number, String], required: true },
  },
  computed: {
    randomNumbers() {
      return Date.now() + Math.trunc(Math.random() * 10000);
    },
    stars() {
      if (this.rating > 0 && this.rating < 1) {
        return 0.5;
      }

      if (this.rating > 1 && this.rating < 2) {
        return 1.5;
      }

      if (this.rating > 2 && this.rating < 3) {
        return 2.5;
      }

      if (this.rating > 3 && this.rating < 4) {
        return 3.5;
      }

      if (this.rating > 4 && this.rating < 5) {
        return 4.5;
      }

      return this.rating;
    },
  },
};
</script>

<style lang="scss">
.rating-stars {
  height: 28px;
  white-space: nowrap;

  svg {
    width: 24px;
    height: 24px;

    &:not(.filled):not(.half) {
      g path[fill] {
        fill: transparent;
      }
    }

    &.filled {
      path {
        fill: var(--main-yellow);
      }
    }

    &.filled path,
    &.half path.first-half {
      fill: var(--main-yellow);
    }

    &.half path.second-half {
      fill: transparent;
    }
  }
}
</style>
